<template>
  <div>
    <div class="flex items-start main">
      <table class="mb-5 mt-5">
        <tr>
          <th></th>
          <th>定価</th>
          <th>1～10本</th>
          <th>11～50本</th>
          <th>51本～</th>
        </tr>
        <tr v-for="(c, i) in price1" :key="i" class="hover-color text-left">
          <th>
            <div v-if="c.name" :class="c.class" class="p-1 ml-1 mb-1">
              {{ c.name }}
            </div>
          </th>
          <td>
            <div>
              <NumericTextInput
                name="price"
                class="text-right rounded border-gray-300 w-28 ml-5 bg-teal-50"
                v-model="price1[i].price"
                @change="changeData(price1[i])"
              />
            </div>
          </td>
          <td class="px-6">{{ getPrice1(c) }}</td>
          <td class="px-6">{{ getPrice2(c) }}</td>
          <td class="px-6">{{ getPrice3(c) }}</td>
        </tr>
      </table>
    </div>
  </div>
</template>
<script>

import NumericTextInput from '@components/NumericTextInput.vue'
import * as utils from '@libs/utils'
import BigNumber from 'bignumber.js'

/**
 * 消火器交換
 */
const code = '30'

export default {
  components: {
    NumericTextInput,
  },

  props: {
    code: {
      type: String
    }
  },

  data() {
    return {
      // カラム
      column1: [],
      // 単価
      price1: [],
    }
  },

  created() {
    this.dataByCategory()
  },

  computed: {
    /**
     * 1～10本の値段
     */
    getPrice1() {
      return(row) => {
        if (row && ['1', '2', '3', '4'].includes(row.priceCode)) {
          let rate = 0
          switch (row.priceCode) {
            case '1': // 粉末消火器：モリタ宮田MEA10B
              rate = 0.5
              break;
            case '2': // 粉末消火器：ハツタPEP-10N
              rate = 0.6
              break;
            case '3': // 住宅用消火器：モリタ宮田VF1HA
            case '4': // 強化液消火器：モリタ宮田LF3
              rate = 0.7
              break;
          }
          const res = Math.ceil(BigNumber(row.price).times(rate).div(100)) * (100)
          const rate2 = Number(BigNumber(rate).times(100))
          return '（定価の' + rate2 + '%）' + res.toLocaleString()
        }
        return ''
      }
    },

    /**
     * 11～50本の値段
     */
    getPrice2() {
      return(row) => {
        if (row && ['1', '2', '3', '4'].includes(row.priceCode)) {
          let rate = 0
          switch (row.priceCode) {
            case '1':
              rate = 0.45
              break;
            case '2':
              rate = 0.55
              break;
            case '3':
            case '4':
              rate = 0.65
              break;
          }
          const res = Math.ceil(BigNumber(row.price).times(rate).div(100)) * (100)
          const rate2 = Number(BigNumber(rate).times(100))
          return '（定価の' + rate2 + '%）' + res.toLocaleString()
        }
        return ''
      }
    },

    /**
     * 51～の値段
     */
    getPrice3() {
      return(row) => {
        if (row && ['1', '2', '3', '4'].includes(row.priceCode)) {
          let rate = 0
          switch (row.priceCode) {
            case '1':
              rate = 0.4
              break;
            case '2':
              rate = 0.5
              break;
            case '3':
            case '4':
              rate = 0.6
              break;
          }
          const res = Math.ceil(BigNumber(row.price).times(rate).div(100)) * (100)
          const rate2 = Number(BigNumber(rate).times(100))
          return '（定価の' + rate2 + '%）' + res.toLocaleString()
        }
        return ''
      }
    }
  },
  
  methods: {
    /**
     * 単価データを取得
     */
    async dataByCategory() {

      // カテゴリーに関するデータ取得
      const list = utils.clone(this.$store.getters.estimateItemPriceList)
      this.price1 = list.filter((l) => {
        return l.parentCode == code
      })
    },

    /**
     * 変更イベント
     */
    changeData(target) {
      target.itemName = target.name
      this.$emit('changePrice', target)
    }
  }
}
</script>
<style scoped>
.hover-color:hover {
  background: rgba(163, 231, 228, 0.67) !important;
  color: rgb(16, 16, 208);
}
</style>
